import React__default from 'react';
import { Typography, Space, Avatar } from '@sravni/react-design-system';
import { useAnalytics } from '@sravni/react-utils';

var modules_7deccb6d = {"expertBadge":"_dhsg1v","nameWrapper":"_1kygg31"};
import "./assets/AuthorInfo.css";

var ExpertBadge = function (_a) {
    var className = _a.className;
    return (React__default.createElement("svg", { width: "12", height: "12", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className },
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m6.213 1.474 1.36-.44a.69.69 0 0 1 .827.341l.65 1.274a.69.69 0 0 0 .3.3l1.259.643c.31.159.46.52.352.852l-.435 1.344a.692.692 0 0 0 0 .424l.44 1.361a.69.69 0 0 1-.341.826l-1.274.65a.69.69 0 0 0-.3.301l-.652 1.274a.689.689 0 0 1-.826.342l-1.36-.44a.692.692 0 0 0-.425 0l-1.361.44a.69.69 0 0 1-.826-.342L2.95 9.35a.69.69 0 0 0-.301-.3l-1.274-.651a.689.689 0 0 1-.342-.826l.44-1.361a.692.692 0 0 0 0-.425l-.44-1.36a.69.69 0 0 1 .342-.827l1.274-.65a.687.687 0 0 0 .3-.3l.651-1.275a.69.69 0 0 1 .826-.342l1.361.44a.684.684 0 0 0 .425 0Z", fill: "#00AFFF", stroke: "#00AFFF", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.866 4.312a.375.375 0 0 1 .606.437l-.04.055-2.604 3a.375.375 0 0 1-.484.071l-.055-.042-1.895-1.758a.375.375 0 0 1 .457-.592l.054.042 1.61 1.494 2.351-2.707Z", fill: "#fff" })));
};

var AuthorInfo$1 = function (_a) {
    var id = _a.id, name = _a.name, label = _a.label, hasLink = _a.hasLink, avatarUrl = _a.avatarUrl, hasBadge = _a.hasBadge, _b = _a.labelPosition, labelPosition = _b === void 0 ? 'bottom' : _b;
    var pushEvent = useAnalytics().pushEvent;
    var handleClick = function () {
        pushEvent({
            event: 'adEvent',
            eventCategory: 'Рейтинг пользователей',
            eventAction: 'Переход в профиль',
            eventLabel: "/u/".concat(id, "/")
        });
    };
    var labelBlock = label && (React__default.createElement(Typography.Text, { size: 12, className: 'h-color-D100' },
        React__default.createElement("span", { dangerouslySetInnerHTML: { __html: label } })));
    return (React__default.createElement(Space, { size: 8 },
        React__default.createElement(Avatar, { src: "".concat(avatarUrl, "/").concat(id || 0, "-xs.svg"), size: 36 }),
        React__default.createElement("div", { className: modules_7deccb6d.nameWrapper },
            labelPosition === 'top' && labelBlock,
            React__default.createElement(Space, { align: 'center' },
                React__default.createElement(Typography.Text, { className: 'h-color-D100', size: 14, strong: true }, hasLink ? (React__default.createElement(Typography.Link, { color: 'dark', href: "/u/".concat(id, "/"), onClick: handleClick }, name)) : (name)),
                hasBadge && React__default.createElement(ExpertBadge, { className: modules_7deccb6d.expertBadge })),
            labelPosition === 'bottom' && labelBlock)));
};

export { AuthorInfo$1 as AuthorInfo };
